import About from './About.vue';

export default About;
